"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfavAction;
(function (SfavAction) {
    SfavAction.ON_TOGGLE_FAV = 'ON_TOGGLE_FAV';
    SfavAction.SET_FAV = 'SET_FAV';
    SfavAction.ADD_FAV = 'ADD_FAV';
    SfavAction.SET_RECENTLY_VIEW_LIST = 'SET_RECENTLY_VIEW_LIST';
    SfavAction.SET_SAVE_SEARCH_LIST = 'SET_SAVE_SEARCH_LIST';
    SfavAction.ON_SET_FAV_LIST = 'ON_SET_FAV_LIST';
    SfavAction.ON_SET_SAVE_SEARCH_LIST = 'ON_SET_SAVE_SEARCH_LIST';
    SfavAction.ON_SET_FOLLOWING_PLACE_LIST = 'ON_SET_FOLLOWING_PLACE_LIST';
    SfavAction.SET_DESKTOP_FAV = 'SET_DESKTOP_FAV';
    SfavAction.ON_REMOVE_FAV = 'ON_REMOVE_FAV';
    SfavAction.ON_REMOVE_SAVE_SERACH_CLICKED = 'ON_REMOVE_SAVE_SERACH_CLICKED';
    SfavAction.ON_SAVE_SERACH_CLICKED = 'ON_SAVE_SERACH_CLICKED';
    SfavAction.SET_RECENTLY_VIEW_FROM_LOCAL = 'SET_RECENTLY_VIEW_FROM_LOCAL';
    SfavAction.SET_SAVE_SEARCH_FROM_REMOTE = 'SET_SAVE_SEARCH_FROM_REMOTE';
    SfavAction.SET_FAV_ACTIVE = 'SET_FAV_ACTIVE';
    SfavAction.ON_CONTACT_AGENT_CLICKED = 'ON_CONTACT_AGENT_CLICKED';
    SfavAction.PARSE_LEGACY_BOOKMARKS = 'PARSE_LEGACY_BOOKMARKS';
    SfavAction.SET_RECENT_IS_SAVED = 'SET_RECENT_IS_SAVED';
    SfavAction.INIT_SUBSECTION_FAV_STATE = 'INIT_SUBSECTION_FAV_STATE';
    SfavAction.CLOSE_ALL_FAV_SUBSECTION = 'CLOSE_ALL_FAV_SUBSECTION';
    SfavAction.ON_SAVE_ITEM_CLICKED = 'ON_SAVE_ITEM_CLICKED';
    SfavAction.SET_SERACH_SET_ACTIVE = 'SET_SERACH_SET_ACTIVE';
    SfavAction.ON_EDIT_SAVE_SERACH_CLICKED = 'ON_EDIT_SAVE_SERACH_CLICKED';
    SfavAction.setDesktopFav = typesafe_actions_1.createAction(SfavAction.SET_DESKTOP_FAV, function (resolve) { return function (state) { return resolve(state); }; });
    SfavAction.onToggleFav = typesafe_actions_1.createAction(SfavAction.ON_TOGGLE_FAV, function (resolve) { return function () { return resolve(); }; });
    SfavAction.setFav = typesafe_actions_1.createAction(SfavAction.SET_FAV, function (resolve) { return function (state) { return resolve(state); }; });
    SfavAction.setRecentlyViewedList = typesafe_actions_1.createAction(SfavAction.SET_RECENTLY_VIEW_LIST, function (resolve) { return function (historyItems) {
        return resolve(historyItems);
    }; });
    SfavAction.setSaveSearchList = typesafe_actions_1.createAction(SfavAction.SET_SAVE_SEARCH_LIST, function (resolve) { return function (saveSearches) {
        return resolve(saveSearches);
    }; });
    SfavAction.onSetFavList = typesafe_actions_1.createAction(SfavAction.ON_SET_FAV_LIST, function (resolve) { return function (saveResultItems) {
        return resolve(saveResultItems);
    }; });
    SfavAction.onSetSaveSearchList = typesafe_actions_1.createAction(SfavAction.ON_SET_SAVE_SEARCH_LIST, function (resolve) { return function (saveSearches) {
        return resolve(saveSearches);
    }; });
    SfavAction.onSetFollowingPlaceList = typesafe_actions_1.createAction(SfavAction.ON_SET_FOLLOWING_PLACE_LIST, function (resolve) { return function (saveSearches) {
        return resolve(saveSearches);
    }; });
    SfavAction.onRemoveFav = typesafe_actions_1.createAction(SfavAction.ON_REMOVE_FAV, function (resolve) { return function (id) {
        return resolve(id);
    }; });
    SfavAction.onRemoveSaveSearchClicked = typesafe_actions_1.createAction(SfavAction.ON_REMOVE_SAVE_SERACH_CLICKED, function (resolve) {
        return function (id) {
            return resolve(id);
        };
    });
    SfavAction.onSaveSearchClicked = typesafe_actions_1.createAction(SfavAction.ON_SAVE_SERACH_CLICKED, function (resolve) {
        return function (item) {
            return resolve(item);
        };
    });
    SfavAction.setSaveSearchFromRemote = typesafe_actions_1.createAction(SfavAction.SET_SAVE_SEARCH_FROM_REMOTE, function (resolve) { return function () { return resolve(); }; });
    SfavAction.setFavActive = typesafe_actions_1.createAction(SfavAction.SET_FAV_ACTIVE, function (resolve) { return function (state) { return resolve(state); }; });
    SfavAction.onContactAgentClicked = typesafe_actions_1.createAction(SfavAction.ON_CONTACT_AGENT_CLICKED, function (resolve) {
        return function () { return resolve(); };
    });
    SfavAction.parseLegacyBookmarks = typesafe_actions_1.createAction(SfavAction.PARSE_LEGACY_BOOKMARKS, function (resolve) {
        return function () { return resolve(); };
    });
    SfavAction.setRecentIsSaved = typesafe_actions_1.createAction(SfavAction.SET_RECENT_IS_SAVED, function (resolve) { return function (id, state) { return resolve({ id: id, state: state }); }; });
    SfavAction.initSubsectionSaveState = typesafe_actions_1.createAction(SfavAction.INIT_SUBSECTION_FAV_STATE, function (resolve) { return function () { return resolve(); }; });
    SfavAction.closeAllSubsection = typesafe_actions_1.createAction(SfavAction.CLOSE_ALL_FAV_SUBSECTION, function (resolve) { return function () { return resolve(); }; });
    SfavAction.onSaveItemClicked = typesafe_actions_1.createAction(SfavAction.ON_SAVE_ITEM_CLICKED, function (resolve) { return function (searchSet) { return resolve(searchSet); }; });
    SfavAction.setSearchSetActive = typesafe_actions_1.createAction(SfavAction.SET_SERACH_SET_ACTIVE, function (resolve) { return function (searchSet) { return resolve(searchSet); }; });
    SfavAction.onEditSaveSearchClicked = typesafe_actions_1.createAction(SfavAction.ON_EDIT_SAVE_SERACH_CLICKED, function (resolve) {
        return function () { return resolve(); };
    });
})(SfavAction || (SfavAction = {}));
exports.default = SfavAction;
